<template>
  <div class="nav_left">
    <a class="logo" href="/">
      <img src="/static/img/logo.png">
      <span class="h5pay">h5 pay平台</span>
    </a>
    <el-scrollbar wrapClass="scrollbar-wrapper">
      <el-menu
        mode="vertical"
        :show-timeout="200"
        :default-active="$route.path"
        :collapse="isCollapse"
        background-color="#304156"
        text-color="#bfcbd9"
        active-text-color="#409EFF"
        router
      >
        <!--<sidebar-item :routes="routes"></sidebar-item>-->
        <sidebar-item v-for="route in routes" :key="route.name" :menu="route" router :base-path="route.path"></sidebar-item>
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'

export default {
  components: { SidebarItem },
  computed: {
    ...mapGetters([
      'sidebar'
    ]),
    routes() {
      // console.log('this.$router.options.routes', this.$router.options.routes);
      return this.$router.options.routes
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  }
}
</script>
<style scoped>
  .nav_left{
    background: #304156;
  }
  .logo{
    margin-top: 15px;
    margin-left: 6px;
    margin-bottom: 15px;
    height: 30px;
    line-height: 30px;
    overflow: hidden;
  }
  .logo img{
    width: 28px;
    vertical-align: top;
  }
  .logo .h5pay{
    color: #fff;
    font-size: 16px;
    padding-left: 6px;
  }

</style>



// WEBPACK FOOTER //
// index.vue?22cca1ff